import { __awaiter, __generator } from "tslib";
import * as React from 'react';
import { composer } from '../../component-decorators/composer';
import { Box, Text, EmptyState, Button } from 'wix-style-react';
import s from './open-app-with-params.scss';
import { config } from '../../config';
import { Path } from '../..';
import { useConfigContext } from '../../config-context';
import { postDeepLinkEditorCache } from '../../api/api';
import { useState } from "react";
export var OpenAppWithParams = composer()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var appId = _a.appId, params = _a.params, t = _a.t, marketplaceStore = _a.marketplaceStore, options = _a.options;
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(null), appFromInstalled = _c[0], setAppFromInstalled = _c[1];
    // tslint:disable-next-line:react-hooks-nesting
    var finishAppInstall = useConfigContext().finishAppInstall;
    var sendOptionsAndOpenApp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var optionsObj;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    optionsObj = {
                        key: marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.metaSiteId,
                        data: JSON.parse(options),
                    };
                    return [4 /*yield*/, postDeepLinkEditorCache(marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.metaSiteId, optionsObj)];
                case 1:
                    _b.sent();
                    finishAppInstall((_a = appFromInstalled === null || appFromInstalled === void 0 ? void 0 : appFromInstalled.webSolutionBase) === null || _a === void 0 ? void 0 : _a.id, appFromInstalled === null || appFromInstalled === void 0 ? void 0 : appFromInstalled.installedVersion, options);
                    return [2 /*return*/];
            }
        });
    }); };
    // tslint:disable-next-line:react-hooks-nesting
    React.useEffect(function () {
        var _a, _b;
        var app = (_a = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.find(function (installedApp) { return installedApp.webSolutionBase.id === appId; });
        if (app) {
            setAppFromInstalled(app);
            // @ts-ignore
            sendOptionsAndOpenApp();
            setIsLoading(false);
        }
        if (((_b = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.installedApps) === null || _b === void 0 ? void 0 : _b.length) >= 0) {
            setIsLoading(false);
        }
    });
    if (isLoading) {
        return (React.createElement(Box, { align: "center" }));
    }
    if (appFromInstalled) {
        return (React.createElement(Box, { className: s.openApp, marginTop: '90px', marginLeft: '538px' },
            React.createElement(Box, { verticalAlign: 'middle', direction: 'vertical', align: 'center' },
                React.createElement(Box, { className: s.loader }),
                React.createElement(Text, { skin: "standard", weight: "normal", className: s.text },
                    t('marketplace.adding.element1', {
                        appName: appFromInstalled === null || appFromInstalled === void 0 ? void 0 : appFromInstalled.webSolutionBase.name,
                    }),
                    React.createElement("br", null),
                    t('marketplace.adding.element2')))));
    }
    return (React.createElement(EmptyState, { theme: 'page-no-border', image: React.createElement("img", { style: {
                width: '120px',
                height: '120px',
            }, src: config.marketplaceStaticsUrl + "/assets/images/empty-state-generic-nothing-here-desert.svg" }), title: t('marketplace.open-app.title'), subtitle: t('marketplace.open-app.subtitle') },
        React.createElement(Button, { size: 'medium', onClick: function () {
                config.goto({
                    path: Path.WEB_SOLUTION,
                    slug: appId,
                    hideMenu: false,
                });
            } }, t('marketplace.goto.appPage'))));
});
//# sourceMappingURL=open-app-with-params.js.map